import React, { Dispatch, SetStateAction, useState } from 'react';

import Select, { SelectOption } from '@amzn/meridian/select';

import { isEmpty, isUndefined } from 'lodash';

interface IDataSelector<T> {
    readonly id: T | undefined;
    readonly setId: Dispatch<SetStateAction<T | undefined>>;
    readonly idMap: Map<T, string>;
    readonly prefix?: string;
    readonly title: string;
}

type DataSelectorType<T = any> = React.FC<IDataSelector<T>>;

export const DataSelector: DataSelectorType = (props) => {
    const { id, setId, title } = props;
    const [queryValue, setQueryValue] = useState('');

    const lowerQuery = queryValue.toLowerCase();
    const selectOptions: JSX.Element[] = Array.from(props.idMap.entries())
        .filter(
            ([id, name]) =>
                isEmpty(queryValue) || name.toLowerCase().includes(lowerQuery) || id.toLowerCase().includes(lowerQuery)
        )
        .map(([id, name]) => createSelectOption(name, id));

    // we want the select to show something even if the ID doesn't
    // match a known contract
    if (!isUndefined(id) && !props.idMap.has(id)) {
        selectOptions.push(createSelectOption(`Unknown ${title}`, id));
    }

    // if the user has put in an integer value that doesn't match anything
    // add an "unknown" option for them to select. this will make the component
    // more robust to issues as users can still manually enter the ID
    if (selectOptions.length === 0 && queryValue.length > 0 && !isNaN(Number.parseInt(queryValue))) {
        selectOptions.push(createSelectOption(`Unknown ${title}`, queryValue));
    }

    return (
        <Select
            prefix={props.prefix ?? props.title}
            placeholder={`Select ${title}...`}
            searchQuery={queryValue}
            onSearch={setQueryValue}
            value={id}
            onChange={(newId) => setId(newId)}
        >
            {selectOptions}
        </Select>
    );
};

function createSelectOption(name: string, id: string): JSX.Element {
    return <SelectOption label={`${name} (${id})`} value={id} key={id} />;
}
